export const TableConfig: any = {
    SCREENS_LIST: {
        HEADER: ['ID', 'Name', 'Type', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Type: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    SCREENS_MANAGE: {
        HEADER: ['ID', 'Name', 'Status', 'Action'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Status: 'VISIBLE_ICON',
            Action: 'toggler',
        },
    },
    CATEGORY: {
        HEADER: ['ID', 'Name', 'Aspect Ratio', 'SubType', 'Visible', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Aspect Ratio': 'text',
            // Image: 'IMAGE',
            SubType: 'text',
            Visible: 'VISIBLE_ICON',
            Actions: 'CATEGORY_ACTION',
        },
    },
    PUBLISH: {
        HEADER: ['ID', 'Name', 'Schedule', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Schedule: 'text',
            Actions: 'PUBLISH_ACTION',
        },
    },
    CPP_LIST_SEARCH: {
        HEADER: [
            'ID',
            'Name',
            'Thumbnail',
            'Type',
            'Business Type',
            // 'Platform Rights',
            'Language',
            'Provider',
            'Landscape',
            'Portrait',
            'Actions',
        ],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            Type: 'text',
            'Business Type': 'text',
            // 'Platform Rights': 'text',
            Language: 'text',
            Provider: 'text',
            Landscape: 'VISIBLE_ICON',
            Portrait: 'VISIBLE_ICON',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
            // AutoUpdate: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    CATEGORY_FLOW_SEARCH: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Type', 'Source', 'Actions', 'AutoUpdate'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            Type: 'text',
            Source: 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
            AutoUpdate: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    PROMOTIONAL_CATEGORY_PICKER: {
        HEADER: ['ID', 'Name', 'Image', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Image: 'IMAGE',
            Status: 'VISIBLE_ICON',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    /** Rail (etc.) with subType Promotion — matches CMS layout: Thumbnail + Source column */
    PROMOTION_SUBTYPE_PICKER: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Source', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            Source: 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    CATEGORY_LIST_DATA: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Type', 'Source', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            Type: 'text',
            Source: 'text',
            Actions: 'CATEGORY_LIST_DATA_ACTION',
        },
    },
    CATEGORY_PAGE_LIST_DATA: {
        HEADER: ['ID', 'Name', 'Display Name', 'Thumbnail', 'Type', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Display Name': 'text',
            Thumbnail: 'IMAGE',
            Type: 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION', //'CATEGORY_LIST_DATA_ACTION',
        },
    },
    CATEGORY_LIST_EPG_EPISODE: {
        HEADER: [
            'SrNo',
            'Channel Id',
            'Title',
            'Image',
            'Show Date',
            'Start Time',
            'End Time',
            'Actions',
            'AutoUpdate',
        ],
        COMPONENT_TYPE: {
            SrNo: 'ID_ICON',
            'Channel Id': 'text',
            Title: 'text',
            Image: 'IMAGE',
            'Show Date': 'text',
            'Start Time': 'text',
            'End Time': 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
            AutoUpdate: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    CATEGORY_LIST_EPG_PROGRAM: {
        HEADER: ['ShowId', 'Title', 'Image', 'Actions', 'AutoUpdate'],
        COMPONENT_TYPE: {
            ShowId: 'ID_ICON',
            Title: 'text',
            Image: 'IMAGE',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
            AutoUpdate: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    CATEGORY_LIST_EPG_CHANNEL: {
        HEADER: ['woiId', 'Channel', 'Image', 'Actions'],
        COMPONENT_TYPE: {
            woiId: 'ID_ICON',
            Channel: 'text',
            Image: 'IMAGE',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
            // AutoUpdate: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    CATEGORY_LIST_DEEPLINK_SEARCH: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Type', 'Source', 'Actions', 'AutoUpdate'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            Type: 'text',
            Source: 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
            AutoUpdate: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    SCHEDULE_RAIL_TABLE: {
        HEADER: ['ID', 'Name', 'Aspect Ratio', 'Type', 'SubType', 'Visible', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Aspect Ratio': 'text',
            Type: 'text',
            // Image: 'IMAGE',
            SubType: 'text',
            Visible: 'VISIBLE_ICON',
            Actions: 'SCHEDULE_TABLE_ACTION',
        },
    },
    SCHEDULE_LIST_TABLE: {
        HEADER: ['ID', 'Name', 'Aspect Ratio', 'Type', 'SubType', 'Schedule', 'Visible', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Aspect Ratio': 'text',
            Type: 'text',
            //  Image: 'IMAGE',
            SubType: 'text',
            Schedule: 'text',
            Visible: 'VISIBLE_ICON',
            Actions: 'SCHEDULE_LIST_ACTION',
        },
    },
    SCHEDULE_ITEMS_TABLE: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Content Type', 'Source', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            'Content Type': 'text',
            Source: 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },

    SCHEDULE_ITEMS_LIST_TABLE: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Content Type', 'Source', 'Schedule', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            'Content Type': 'text',
            Source: 'text',
            Schedule: 'MULTI_SCHEDULE',
            Actions: 'SCHEDULE_ITEMS_LIST_ACTION',
        },
    },
    DASHBOARD_AUDIT_TABLE: {
        HEADER: ['Description', 'URL', 'Data', 'Time'],
        COMPONENT_TYPE: {
            Description: 'text',
            URL: 'text',
            Data: 'DASHBOARD_LIST_DATA',
            Time: 'text',
        },
    },
    LANG_GENRE_BROADCASTER_TABLE: {
        HEADER: ['ID', 'Name', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    LANG_TABLE: {
        HEADER: ['ID', 'Code', 'Name', 'Display Name', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Code: 'text',
            Name: 'text',
            'Display Name': 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    CHANNEL_LIST_TABLE: {
        HEADER: ['ID', 'Logo', 'Name', 'Status', 'isPinned', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Logo: 'IMAGE',
            Name: 'text',
            Status: 'VISIBLE_ICON',
            isPinned: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    CHANNEL_REORDER_TABLE: {
        HEADER: ['ID', 'Logo', 'Name'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Logo: 'IMAGE',
            Name: 'text',
        },
    },
    PARENT_CHILD_MAPPING_TABLE: {
        HEADER: ['ID', 'Image', 'Name', 'Status'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Image: 'IMAGE',
            Name: 'text',
            Status: 'VISIBLE_ICON',
        },
    },

    PARENT_CHILD_SEARCH_MAPPING_TABLE: {
        HEADER: ['ID', 'Image', 'Name', 'Status', 'Type', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Image: 'IMAGE',
            Name: 'text',
            Status: 'VISIBLE_ICON',
            Type: 'DROPDOWN_TYPE',
            // isHidden: 'VISIBLE_ICON',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    METADATA: {
        HEADER: [
            'ID',
            'Name',
            'Thumbnail',
            'Content Type',
            'Business Type',
            'Language',
            'Provider',
            'Status',
            'Actions',
        ],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            'Content Type': 'text',
            'Business Type': 'text',
            Language: 'text',
            Provider: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'METADATA_ACTION',
        },
    },
    METADATA_LIST: {
        HEADER: [
            'ID',
            'Name',
            'Thumbnail',
            'Content Type',
            'Business Type',
            'Language',
            'Provider',
            'Status',
            'Actions',
        ],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            'Content Type': 'text',
            'Business Type': 'text',
            Language: 'text',
            Provider: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'METADATA_ACTION',
        },
    },
    METADATA_LIST_AUDIOBOOK: {
        HEADER: [
            'ID',
            'Name',
            'Thumbnail',
            'Content Type',
            'Chapter Number',
            'Business Type',
            'Language',
            'Provider',
            'Status',
            'Actions',
        ],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            'Content Type': 'text',
            'Chapter Number': 'text',
            'Business Type': 'text',
            Language: 'text',
            Provider: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'METADATA_ACTION',
        },
    },
    CONFIG: {
        HEADER: ['Product', 'Platform', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            Product: 'text',
            Platform: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'METADATA_ACTION',
        },
    },
    MULTILINGUAL: {
        HEADER: ['ID', 'Source', 'Name', 'Description', 'Language', 'Status'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Source: 'text',
            Name: 'text',
            Description: 'text',
            Language: 'text',
            Status: 'VISIBLE_ICON',
        },
    },
    MULTILINGUAL_CREATE: {
        HEADER: ['ID', 'Name', 'Description', 'Action'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Description: 'text',
            Action: 'MULTILINGUAL_ACTION',
        },
    },

    MASTERCONFIG_LIST: {
        HEADER: ['Key', 'Value', 'Description', 'Updated By', 'Action'],
        COMPONENT_TYPE: {
            Key: 'text',
            Value: 'text',
            Description: 'text',
            'Updated By': 'text',
            Action: 'SCREENS_ACTION',
        },
    },

    FASTCONFIG_LIST: {
        HEADER: [
            'Channel Name',
            'Category Name',
            'Start Duration',
            'End Duration',
            'OverWrite',
            'Repeat',
            'Status',
            'Action',
        ],
        COMPONENT_TYPE: {
            'Channel Name': 'text',
            'Category Name': 'text',
            'Start Duration': 'text',
            'End Duration': 'text',
            OverWrite: 'VISIBLE_ICON',
            Status: 'VISIBLE_ICON',
            Repeat: 'VISIBLE_ICON',
            Action: 'SCREENS_ACTION',
        },
    },
    PARTNERCONFIG_LIST: {
        HEADER: ['ID', 'Type', 'Provider', 'Action'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Type: 'text',
            Provider: 'text',
            Action: 'SCREENS_ACTION',
        },
    },
    EPG_DATA: {
        HEADER: ['SrNo', 'Channel Name', 'Title', 'Show Date', 'Start', 'End', 'Show ID', 'Channel ID', 'Actions'],
        COMPONENT_TYPE: {
            SrNo: 'ID_ICON',
            'Channel Name': 'text',
            Title: 'text',
            'Show Date': 'text',
            Start: 'text',
            End: 'text',
            'Show ID': 'text',
            'Channel ID': 'text',
            Actions: 'METADATA_ACTION',
        },
    },
    TRAILER_EDIT: {
        HEADER: ['Type', 'Content Id', 'Name', 'Actions'],
        COMPONENT_TYPE: {
            Type: 'text',
            'Content Id': 'text',
            Name: 'text',
            Actions: 'SCREENS_ACTION',
        },
    },
    TRAILER_EDIT_MODAL: {
        HEADER: ['Content Id', 'Name', 'Select Action'],
        COMPONENT_TYPE: {
            'Content Id': 'text',
            Name: 'text',
            'Select Action': 'TRAILER_SEARCH_ACTION',
        },
    },

    DEEPLINK_LIST: {
        HEADER: ['ID', 'Name', 'Type', 'Deeplink URL', 'Image', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Type: 'text',
            'Deeplink URL': 'DASHBOARD_LIST_DATA',
            Image: 'IMAGE',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    CTACONFIG_LIST: {
        HEADER: ['ID', 'Name', 'Position', 'Product', 'Platform', 'Screens', 'Visible', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Position: 'text',
            Product: 'text',
            Platform: 'text',
            Screens: 'text',
            Visible: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    AUDIT_LOG: {
        HEADER: ['ID', 'Time', 'User', 'URL', 'Class', 'Handler', 'Action', 'Description'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Time: 'text',
            User: 'text',
            URL: 'text',
            Class: 'text',
            Handler: 'text',
            Action: 'DASHBOARD_LIST_DATA',
            Description: 'text',
        },
    },

    REGIONS_LIST: {
        HEADER: ['ID', 'Name', 'Code', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Code: 'text',
            Actions: 'SCREENS_ACTION',
        },
    },
    PLANS: {
        HEADER: ['ID', 'Name', 'Transactional Type', 'Tier', 'Quality', 'Price', 'Platform', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Transactional Type': 'text',
            Tier: 'text',
            Quality: 'text',
            Price: 'text',
            Platform: 'DASHBOARD_LIST_DATA',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    TIERS: {
        HEADER: ['ID', 'Name', 'Transactional Type', 'Plans', 'Default Plan', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Transactional Type': 'text',
            Plans: 'text',
            'Default Plan': 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    UITEMPLATE_LIST: {
        HEADER: ['ID', 'Name', 'Template', 'Category List', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Template: 'DASHBOARD_LIST_DATA',
            'Category List': 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    MULTISCHEDULE_LIST: {
        HEADER: ['Start Date', 'Start Time', 'End Date', 'End Time', 'Actions'],
        COMPONENT_TYPE: {
            'Start Date': 'text',
            'Start Time': 'text',
            'End Date': 'text',
            'End Time': 'text',
            Actions: 'SCHEDULE_LIST_ACTION',
        },
    },
    MULTISCHEDULE_LIST_MODAL: {
        HEADER: ['Start Date', 'Start Time', 'End Date', 'End Time'],
        COMPONENT_TYPE: {
            'Start Date': 'text',
            'Start Time': 'text',
            'End Date': 'text',
            'End Time': 'text',
        },
    },
    AUTO_CURATE: {
        HEADER: ['Product', 'Platform', 'Screen', 'Category', 'Source', 'Items', 'Schedule', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            Product: 'text',
            Platform: 'text',
            Screen: 'text',
            Category: 'text',
            Source: 'text',
            Items: 'text',
            Schedule: 'AUTO_CURATE_SCHEDULE',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },
    AUTO_CURATE_MODAL: {
        HEADER: ['Name', 'ContentId', 'Image', 'Schedule'],
        COMPONENT_TYPE: {
            Name: 'text',
            ContentId: 'text',
            Image: 'IMAGE_AUTO_CURATE',
            Schedule: 'MULTI_SCHEDULE',
        },
    },
    BUNDLES: {
        HEADER: ['ID', 'Name', 'Banner Art', 'SubType', 'Type', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Banner Art': 'IMAGE_BUNDLE',
            'Aspect Ratio': 'text',
            SubType: 'text',
            Type: 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'BUNDLES_ACTION',
        },
    },
    PREMIUM_LIST_DATA: {
        HEADER: ['woiId', 'Name', 'Image', 'Actions'],
        COMPONENT_TYPE: {
            woiId: 'ID_ICON',
            Name: 'text',
            Image: 'IMAGE',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    BUNDLES_LIST_DATA: {
        HEADER: ['ID', 'Name', 'Thumbnail', 'Source', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Thumbnail: 'IMAGE',
            Source: 'text',
            Actions: 'BUNDLE_LIST_DATA_ACTION',
        },
    },
    BUNDLES_LIST_TABLE_DATA: {
        HEADER: ['ID', 'Name', 'Sub Type', 'Thumbnail', 'Type', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Sub Type': 'text',
            Thumbnail: 'IMAGE',
            Type: 'text',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },
    SERVICES_DATA: {
        HEADER: ['ID', 'Service Id', 'Name', 'Origin', 'Status'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            'Service Id': 'text',
            Name: 'text',
            Origin: 'text',
            Status: 'VISIBLE_ICON',
            // Actions: 'SCREENS_ACTION',
        },
    },
    JIOTV_PLANS_DATA: {
        HEADER: ['Plan ID', 'Name', 'Plan Origin', 'Items', 'Status', 'Is Hidden', 'Actions'],
        COMPONENT_TYPE: {
            'Plan ID': 'ID_ICON',
            Name: 'text',
            'Plan Origin': 'text',
            Items: 'DASHBOARD_LIST_DATA',
            Status: 'VISIBLE_ICON',
            'Is Hidden': 'VISIBLE_ICON',
            Actions: 'PLANS_ACTION',
        },
    },

    PROMOTIONAL_CONTENT_LIST: {
        HEADER: ['ID', 'Name', 'Image', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Image: 'IMAGE',
            Status: 'VISIBLE_ICON',
            Actions: 'SCREENS_ACTION',
        },
    },

    OTT_LIST_DATA: {
        HEADER: ['ID', 'Name', 'Plan Origin', 'Status', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Plan Origin': 'text',
            Status: 'VISIBLE_ICON',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },

    CHANNELS_LIST_DATA: {
        HEADER: ['ID', 'Name', 'Plan Type', 'Business Type', 'Status', 'Services', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            'Plan Type': 'text',
            'Business Type': 'text',
            Status: 'VISIBLE_ICON',
            Services: 'AUTOCOMPLETE_DROPDOWN',
            Actions: 'CATEGORY_LIST_SEARCH_ACTION',
        },
    },

    PLANS_LIST_DATA: {
        HEADER: ['ID', 'Name', 'Type', 'Actions'],
        COMPONENT_TYPE: {
            ID: 'ID_ICON',
            Name: 'text',
            Type: 'text',
            Actions: 'BUNDLE_LIST_DATA_ACTION',
        },
    },

    SONY_VOD_STITCH_COUNTS: {
        HEADER: ['Mapped Shows', 'Unmapped Shows', 'Mapped Movies', 'Unmapped Movies', 'Total Sony VOD Contents'],
        COMPONENT_TYPE: {
            'Mapped Shows': 'text',
            'Unmapped Shows': 'text',
            'Mapped Movies': 'text',
            'Unmapped Movies': 'text',
            'Total Sony VOD Contents': 'text',
        },
    },
    SONY_VOD_CHANNEL_STATUS: {
        HEADER: ['Channel', 'Srno', 'Status', 'Simulcast Id', 'Action'],
        COMPONENT_TYPE: {
            Channel: 'text',
            Srno: 'text',
            Status: 'text',
            'Simulcast Id': 'text',
            Action: 'SERVICES_ACTION',
        },
    },
};
